import {authentication} from "@/services/auth";
import {Device} from "@/services/Device";
import {responses} from "@/utils/responses";
import Swal from "sweetalert2";
import Vue from 'vue'
import {utils} from "@/utils/utils";
import {errorHandler} from "@/services/errorHandler";
import queryStringify from "qs-stringify";
import TimeManager from "@/services/TimeManager";

window.serverApi = `https://lytningtomcat.chrilantech.com/OnlineSalesServer/`
// window.serverApi = `http://192.168.1.25:8080/OnlineSalesServer/`

window.onlineSalesServerApi = serverApi;

window.kazangApi = `https://realtime.pos.co.zm:8443/kazangApi/api/`
 // window.kazangApi = `http://localhost:8080/kazangApi/api/`

window.gateWayApi = `https://realtime.pos.co.zm:8443/SandboxKazangPaymentGateway/api/GateWay/`
 // window.gateWayApi = `http://192.168.1.225:9333/KazangPaymentGateway/api/GateWay/`

window.franchiseTomcatApi = `https://lytningtomcat.chrilantech.com/Franchise_OnlineServer/`
// window.franchiseTomcatApi = `http://DESKTOP-JS3P555:7082/Franchise_OnlineServer/`

window.backOfficeTomcatApi = `https://lytningtomcat.chrilantech.com/Lyt-SoftBackOfficeApi/`
// window.backOfficeTomcatApi = `http://192.168.1.175:8007/BackOfficeApiV3/`

window.backOfficeApiPOST = franchiseTomcatApi+`proxyApi/lytSoftBackOffice/POST`;
window.backOfficeApiGET = franchiseTomcatApi+`proxyApi/lytSoftBackOffice/GET`;


// window.backOfficePlatform = `http://192.168.0.222:8082`;
window.backOfficePlatform = `https://admin.chrilantech.com`;

// window.hardwareApi = `http://192.168.1.140:9090/`;
window.hardwareApi = `http://localhost:9090/`;

window.gateWayApiPOST = franchiseTomcatApi+`proxyApi/gateWay/POST`;
window.gateWayApiGET = franchiseTomcatApi+`proxyApi/gateWay/GET`;

window.subscriptionApiPOST = franchiseTomcatApi+`proxyApi/subscriptionApi/POST`;
window.subscriptionApiGET = franchiseTomcatApi+`proxyApi/subscriptionApi/GET`;

window.franchiseApi = `https://chrilantech.com/LytSoftPosOnline/api/`
// window.franchiseApi = `http://127.0.0.1:8000/api/`

window.franchiseSpringApi = `https://lytningtomcat.chrilantech.com/FranchiseSpringServer/`

window.securityApiWebsocket = "ws://192.168.1.175:8007/BackOfficeApiV3/backofficeApi";

window.auth = authentication;
window.Device = Device;
window.responses = responses;
window.errorHandler = errorHandler
window.routeExceptions = ['login','forgot-password','kazangOnline','test-success','test-failed','initKazangOnline',
    'signup','custom-install','custom-cart'];

const EventBus = new Vue()
window.EventBus = EventBus
window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

window.$utils = utils;
Vue.prototype.$utils = utils;

Vue.prototype.$dateTimeManager = TimeManager;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;
window.stringify = (object) => queryStringify(object);

window.openUrl = (url,target = '_blank') => window.open(url,target,"_blank","toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=yes, width=900, height=700");

window.pageOptions = {
    enabled: true,
    mode: 'pages',
    perPage: 10,
    position: 'bottom',
    perPageDropdown: [10, 100, 200],
    dropdownAllowAll: false,
    jumpFirstOrLast: true,
    pageLabel: 'page', // for 'pages' mode
}
window.encryptObj = (object) => window.btoa(JSON.stringify(object));
window.decryptObj = (string) => window.atob(JSON.parse(string));
